import { render, staticRenderFns } from "./DiscountRules.vue?vue&type=template&id=64cfc980&scoped=true&"
import script from "./DiscountRules.vue?vue&type=script&lang=js&"
export * from "./DiscountRules.vue?vue&type=script&lang=js&"
import style0 from "./DiscountRules.vue?vue&type=style&index=0&id=64cfc980&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cfc980",
  null
  
)

export default component.exports